<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <pb-body-base :busy="busy">
        <template v-slot:default="props">
            <pb-body banner-size="md"
                     :banner-img="fileResourceUrl(cmsHomePage.contentDataSet.home_banner_image.value)"
                     :banner-title="cmsHomePage.contentDataSet.banner_label.value">
                <template slot="title">
                    <b-container>
                        <b-row class="mt-6">
                            <b-col md="6">
                                <b-img v-if="cmsHomePage.contentDataSet"
                                       :src="fileResourceUrl(cmsHomePage.contentDataSet.welcome_image.value)" fluid-grow/>
                            </b-col>
                            <b-col md="6">
                                <h3 v-if="cmsHomePage.contentDataSet"
                                    v-html="cmsHomePage.contentDataSet.welcome_title.value">
                                    {{cmsHomePage.contentDataSet.welcome_title.value}}</h3>
                                <hr class="left"/>
                                <div v-if="cmsHomePage.contentDataSet"
                                     v-html="cmsHomePage.contentDataSet.welcome_text.value">
                                    {{cmsHomePage.contentDataSet.welcome_text.value}}
                                </div>
                            </b-col>
                        </b-row>
                    </b-container>
                </template>
                <template slot="body">
                    <b-container fluid>
                        <b-row class="mt-6">
                            <b-col class="text-center">
                                <h3 class="center-line">SHOP NOW
                                    <hr/>
                                </h3>
                                <pb-category-slider :categories="filteredCategories"/>
                            </b-col>
                        </b-row>
                    </b-container>
                    <b-container>
                        <pb-instagram/>
                        <b-row ref="a" class="mt-6" v-if="filteredNewsList && filteredNewsList.length > 0">
                            <b-col>
                                <h3 class="center-line text-center">NEWS AND EVENTS
                                    <hr/>
                                </h3>
                                <pb-news-list :news-list="filteredNewsList"/>
                            </b-col>
                        </b-row>
                    </b-container>
                </template>
            </pb-body>
        </template>

    </pb-body-base>
</template>


<script>
    import {mapState} from "vuex";
    import {config} from "@shared/_services/config";
    import ContentAPI from "@shared/_api/cms/content";
    import Instagram from "../../../components/Instagram";
    import NewsList from "./NewsList";
    import CategorySlider from "./CategorySlider";
    import DMIContactModal from "../DMIContactModal";

    export default {
        name: 'pb-start',
        data: function () {
            return {
                baseUrl: config.baseUrl + config.resourceUrl,
                cmsHomePage: {},
                loadingNews: true,
                news: [],
                busy: true
            }
        },
        components: {
            'pb-instagram': Instagram,
            'pb-news-list': NewsList,
            'pb-category-slider': CategorySlider,
            'simple-contact-modal': DMIContactModal
        },
        mounted() {
            this.busy = true;
            Promise.all([ContentAPI.fetchPageByName("home"), ContentAPI.fetchListByName("news")])
                .then(([dataHome, dataNews]) => {
                    this.cmsHomePage = dataHome;
                    this.news = dataNews;
                }).finally(() => {
                this.busy = false;
            });


            // this.show = !window.$cookies.isKey('d-p');
            //     window.$cookies.set('d-p', 1,"90D");
        },
        computed: {
            ...mapState('categoryManagement', ['categories']),
            filteredCategories: function() {
                return this.categories.filter(category => (category.webName));
            },
            filteredNewsList: function() {
                if(this.news) {
                    return this.news.filter(item => {

                        let validFrom = item.visible_from ? item.visible_from.value : null,
                            validTo = item.visible_to ? item.visible_to.value : null,
                            currentTime = Date.now();

                        if(validFrom && validTo) {
                            return currentTime < validTo && currentTime > validFrom;
                        } else if(validFrom) {
                            return currentTime > validFrom;
                        } else if(validTo) {
                            return currentTime < validTo;
                        } else {
                            return true;
                        }
                    });
                }
                return [];
            }
        },
    }
</script>
